import React, { Component } from 'react'
import { Form, Icon, Popup,Checkbox } from 'semantic-ui-react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './DateField.scss'

export class DateInputField extends Component {
  constructor() {
    super()
    this.state = {}
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.newValue !== this.state.newValue ||
      nextProps.rbCounterId !== this.state.rbCounterId
    ) {
      this.setState(
        { newValue: nextProps.newValue, rbCounterId: nextProps.rbCounterId },
        () => {
          this.props.fieldName === this.props.id + this.props.shipmentId &&
            this.props.onChange(
              this.props.isInteger
                ? parseFloat(
                  this.state.newValue.replace(/[^\d.-]/g, '')
                ).toFixed(2)
                : this.state.newValue
            )
        }
      )
    }
  }

  errorPopup = (errors, label) => {
    if(!errors){
      return (<label>{label}</label>);
    }else if(!errors.length){
      return (<label>{label}</label>);
    }
    const error = errors.map((info, index) => {
      return (
        <div className='error' key={index}>
          * {info}
        </div>
      )
    })
    return (
      <label style={{"width": "100%"}}>
      <Popup 
        trigger={<Icon 
        name='warning sign'
        color='red' 
        />} 
        content={error || ''}
        style={{ zIndex: 9999999 }}
      />
        <span style={{"width": "90%", "overflow": "ellipsis"}} title={label}>{label}</span>
      </label>
    )
  }

  emptyField = id => {
    !this.props.isInteger && this.props.onChange('')
    let element = document.getElementById(id)
    element.focus()
  }
  render() {
    const {
      id,
      iconPosition,
      width,
      type,
      onChange,
      onBlur,
      disabled,
      value,
      setINPUTID,
      penClicked,
      isInteger,
      shipmentId,
      handleFocus,
      label,
      numberOnly,
      className,
      errors
    } = this.props
    let newLabel = this.errorPopup(errors, label);
    return (
      <Form.Input width={width}
      className={className + (errors&&errors.length?' redBgColor ':' ')}
      
      >
        {newLabel}
        
        <DatePicker
          id={id}
          name={id + shipmentId}
          selected={value ? new Date(parseInt(value) + new Date(Date.now()).getTimezoneOffset() * 60 * 1000) : null}
          onChange={event => {
            let value = !event ? '' : event.getTime()
            value -= new Date(Date.now()).getTimezoneOffset() * 60 * 1000
            onChange(value)
            onBlur && onBlur(value)
          }}
          onMouseDown={e => {
            e.stopPropagation()
            penClicked && penClicked(e)
          }}
          onFocus={event => {
            handleFocus && handleFocus(event)
            setINPUTID && setINPUTID(id + shipmentId)
          }}
          dateFormat={this.props.date?"MMMM d, yyyy":"MMMM d, yyyy h:mm aa"}
          disabled={disabled}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          showTimeSelect={!this.props.date}
          timeFormat="hh:mm aa"
          timeIntervals={15}
        />

        {this.props.component}
                             
      </Form.Input>
    )
  }
}

export default DateInputField
